import sample_1 from './ticino.jpg';
export const ticinoImpressions = {
    sample_1,
};
